/**
 * MemoryIndicator Component
 * Displays conversation memory status and statistics
 */

import React from 'react';
import { FiCpu, FiCheck, FiX } from 'react-icons/fi';
import type { MemoryInfo } from '../../types';

interface MemoryIndicatorProps {
  memoryInfo: MemoryInfo;
  className?: string;
}

export const MemoryIndicator: React.FC<MemoryIndicatorProps> = ({
  memoryInfo,
  className = ''
}) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Memory Status Icon */}
      <div className={`flex items-center gap-2 px-3 py-2 rounded-lg ${
        memoryInfo.hasMemory
          ? 'bg-green-500/20 text-green-400'
          : 'bg-gray-700 text-gray-400'
      }`}>
        <FiCpu size={16} />
        <span className="text-sm font-medium">Memory</span>
        {memoryInfo.hasMemory ? (
          <FiCheck size={14} />
        ) : (
          <FiX size={14} />
        )}
      </div>

      {/* Memory Stats (if active) */}
      {memoryInfo.hasMemory && (
        <div className="flex items-center gap-3 text-xs text-gray-400">
          <div>
            <span className="text-gray-500">Messages:</span>{' '}
            <span className="text-gray-300">{memoryInfo.messageCount}</span>
          </div>
          <div>•</div>
          <div>
            <span className="text-gray-500">Tokens:</span>{' '}
            <span className="text-gray-300">{memoryInfo.tokenCount}</span>
          </div>
          <div>•</div>
          <div>
            <span className="text-gray-500">Context:</span>{' '}
            <span className="text-gray-300">{memoryInfo.contextUtilization}</span>
          </div>
        </div>
      )}

      {/* Long-term Memory Badge */}
      {memoryInfo.hasLongTermMemory && (
        <div className="px-2 py-1 bg-purple-500/20 text-purple-300 text-xs rounded">
          LTM Active
        </div>
      )}

      {/* User Identified Badge */}
      {memoryInfo.userIdentified && (
        <div className="px-2 py-1 bg-blue-500/20 text-blue-300 text-xs rounded">
          User ID'd
        </div>
      )}
    </div>
  );
};

export default MemoryIndicator;
